<template>
    <v-row align="center" justify="center">
      <v-col cols="12"><error-disp v-model="error"/></v-col>

      <v-col cols="12" md="11" lg="8">

        <v-card class="elevation-4">
          <v-card-title class="primary white--text">
            <span v-if="sale">Sale No: <router-link class="primary white--text" :to="saleLink()">{{ sale.sale_id }}</router-link>,&nbsp;</span>
            Credit Note No: <span v-if="credit" class="text-h6">&nbsp;{{ credit.credit_id }}</span>
            <v-chip
              v-if="credit"
              class="ml-auto mr-2"
              v-bind:color="creditStatusColor(credit.credit_status_ref)"
            >{{ credit.credit_status_ref }}</v-chip>
          </v-card-title>

          <template v-if="sale && credit">
            <v-card-text>
              <v-row>
                <v-col cols="12">

                </v-col>
              </v-row>
            <!--****************-->
            <!-- CREDIT NOTE LINES -->
            <!--****************-->
              <v-row align="center" justify="center">
                <v-col cols="12">
                  <v-card class="elevation-1">
                    <v-card-title class="secondary text-body-1 pt-2 pb-2">
                      Credit Values
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>

            <!--****************-->
            <!-- SALE SITES -->
            <!--****************-->
            <v-row v-if="saleSites" align="center" justify="center">
              <v-col cols="12">
                <v-card class="elevation-4">
                  <v-card-title class="secondary text-body-1 pt-2 pb-2">
                    Revert Sites to Stock
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>

            <!--****************-->
            <!-- EVENTS -->
            <!--****************-->
              <v-row v-if="sale && sale.events.length>0" align="center" justify="center">
                <v-col cols="12">
                  <v-card class="elevation-4">
                    <v-card-title class="secondary text-body-1 pt-2 pb-2">
                      Cancel Events
                    </v-card-title>
                    <v-card-text>
                      <v-row class="pt-2" align="center">
                        <v-col cols="6" class="font-weight-bold">
                        Event
                        </v-col>
                        <v-col cols="2" class="font-weight-bold">
                        Cancel Event
                        </v-col>
                      </v-row>
                      <div v-for="event in sale.events" :key="event.event_id">
                        <v-row class="pt-2" align="center">
                        <v-col cols="6" class="pt-2 pb-1">
                          {{formatT(event.event_time)}} - {{event.site_ref}} {{event.event_type}}
                        </v-col>
                        <v-col cols="2" class="pt-2 pb-1">
                          <v-checkbox v-model="event.cancel" @change="dirty = true"></v-checkbox>
                        </v-col>
                        </v-row>
                        <v-row>
                        <v-col cols="12">
                          <v-divider></v-divider>
                        </v-col>

                        </v-row>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

            <!--****************-->
            <!-- SUMMARY -->
            <!--****************-->
              <v-row class="pt-2" align="center">
                <v-col cols="12" class="">
                  <div>Order Total: <b> <span >{{ formatM(sale.price) }}</span></b></div>
                  <div>Receipted: <b> <span >{{ formatM(sale.price_receipted) }}</span></b></div>
                  <div>Outstanding: <b> <span >{{ formatM(sale.price_outstanding) }}</span></b></div>
                  <div>Total Credit: <b> <span >{{ formatM(totalCredit) }}</span></b></div>
                  <div class="red--text">Outstanding after Credit: <b> <span >{{ formatM(sale.price_outstanding - totalCredit) }}</span></b></div>
                </v-col>
              </v-row>
            </v-card-text>

            <!--****************-->
            <!-- ACTIONS -->
            <!--****************-->
            <v-card-actions v-if="!loading">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                dark
                @click="doCancel"
              >
                Cancel
              </v-btn>
            </v-card-actions>
          </template>
          <v-skeleton-loader v-else class="mx-auto" type="article"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import ErrorDisp from '@/components/shared/Error'

export default {
  name: 'tCreditNoteNew',
  components: {
    ErrorDisp
  },
  data () {
    return {
      credit: null,
      sale: null,
      error: null,
      loading: true
    }
  },
  computed: {

  },
  async created () {
    try {

      this.credit = (await this.secureGet('/api/v1/credits/' + this.$route.params.credit_id)).data
      console.log('Credit note: ', this.credit)
      // If the credit status is DRAFT, redirect to new page
      if (this.credit.credit_status_ref == 'DRAFT') {
        this.$router.replace({name: 'New Credit Note', params: { credit_id: this.credit.credit_id }})
        return
      }

      this.sale = (await this.secureGet('/api/v1/sales/' + this.credit.sale_id + '?type=items')).data

      this.loading = false


    } catch (error) {
      this.error = error
    }
  },
  methods: {
    doCancel () {
      this.$router.replace({name: 'Sale', params: { sale_id: this.credit.sale_id }})
    },
    saleLink () {
      if (this.sale.sale_status_ref === 'DRAFT') {
        return {name: 'Edit Sale', params: { customer_id: this.sale.customer_id }}
      } else {
        return {name: 'Sale', params: { sale_id: this.sale.sale_id }}
      }
    }
  }
}

</script>
